module.exports = __webpack_public_path__ + "media/tip3.726bbe72.mp3";